import React, { Component } from 'react';
import { format, subDays } from 'date-fns';
import { OrderByValue, TitleOptions } from './constants/TitleOptions';
import {
  Container,
  HeaderInputs,
  NotesConnectionContent,
  NotesConnectionHeader,
  StyledSearchSecondary,
} from './styles';
import SubHeader from '../../components/SubHeader';
import ConnectionsFilter from './components/ConnectionsFilter';
import ConnectionsTable from './components/ConnectionsTable';
import { Skeleton } from './components/Skeleton';

import { connect } from 'react-redux';
import { changeFilters, getNoteList } from '../../redux/note-connection';
import { paginationOptions } from './constants/Pagination';

class NotesConnection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paginationOptions
    };

    this._onSearch = this._onSearch.bind(this);
    this._onCleanSearch = this._onCleanSearch.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getNoteList());
  }

  _onSearch(value) {
    const { dispatch } = this.props;
    if (value) {
      
      dispatch(changeFilters({ 
        query: value,
        initialPeriod: '',
        finalPeriod: '',
        currentPage: 1
      }));
    } else {
      dispatch(changeFilters({ query: value }));
    }
    dispatch(getNoteList());
  }

  _onCleanSearch() {
    const { dispatch } = this.props;
    
    dispatch(changeFilters({ 
      query: '',
      initialPeriod: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
      finalPeriod: format(new Date(), 'yyyy-MM-dd')
    }));
    dispatch(getNoteList());
  }

  render() {
    const { paginationOptions } = this.state;
    const { pageLimit, currentPage, isFetching, totalItems, searchFieldIsInUse, data } = this.props;

    return (
      <Container>
        <NotesConnectionHeader>
          <SubHeader title="Conexão de Notas" />
          <HeaderInputs>
            <StyledSearchSecondary
              placeholder="Buscar por chave da nota"
              onSearch={this._onSearch}
              onClose={this._onCleanSearch}
              searchFieldIsInUse={searchFieldIsInUse}
              list={data}
              isLoading={false}
            />
            <ConnectionsFilter />
          </HeaderInputs>
        </NotesConnectionHeader>
        <NotesConnectionContent>
          {isFetching ? (
            <Skeleton columnsSize={TitleOptions} />
          ) : (
            <ConnectionsTable
              titleOptions={TitleOptions}
              orderByState={OrderByValue}
              handleHeaderContent={this._onHeaderContent}
              currentPage={currentPage}
              pageLimit={pageLimit}
              totalItems={totalItems}
              paginationOptions={paginationOptions}
              data={data}
            />
          )}
        </NotesConnectionContent>
      </Container>
    );
  }
}

function mapStateToProps (state)  {
  return {
    roles: state.auth.roles,
    pageLimit: state.notesConnection.filters.pageLimit,
    totalItems: state.notesConnection.noteList.data.totalItems,
    currentPage: state.notesConnection.filters.currentPage,
    loggedCompanyId: state.auth.activeCompanyId,
    data: state.notesConnection.noteList.data.list,
    isFetching: state.notesConnection.isFetching,
    searchFieldIsInUse: state.notesConnection.filters.query !== ''
  };
}

export default connect(mapStateToProps)(NotesConnection);
